import "./App.css";

// import { Route, Routes, Link, BrowserRouter } from "react-router-dom";
// import { lazy, Suspense } from "react";

// import MobileHomepage from "./MobileScreens/Screens/homePage"

// import AboutClassplus from "./MobileScreens/Screens/aboutClassplus"
// import ContactUs from "./MobileScreens/Screens/contactUs";

import MobileView from "./MobileScreens/Screens";
import DestopView from "./Desktopscreens";

function App() {
  let mobileView = window.innerWidth > 426 ? false : true;

  return <>{mobileView ? <MobileView /> : <DestopView />}</>;
}

export default App;
